import React, {useCallback, useEffect, useState} from "react";
import {useSelector} from "react-redux";
import PropTypes from 'prop-types';
import {uid} from "react-uid";

import {makeStyles, Tab, Tabs} from "@material-ui/core";
import findByString from "../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import listRequestWrapper from "../../../../../Services/API/listRequestWrapper";
import QuillTextEditor from "../../../../../Utils/QuillTextEditor/QuillTextEditor";

const useStyles = makeStyles({
    tabRoot: {
        padding: 5,
        minWidth: '50px',
        minHeight: 20
    },
    selectedTab: {
        background: '#f7f7f7'
    }
})

const TextEditor = (props) => {
    const {
        setValue, globalValues, path, screenName,
        currentStyles, disabled, containerArrayPath,
        multiLanguage, preserveWhitespace
    } = props;
    const [text, setText] = useState('');
    const {userLanguage} = useSelector(state => state.app);
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const [availableLng, setAvailableLng] = useState([]);
    const multiLanguagePath = multiLanguage ? '.' + selectedLanguage : '';
    const paramPath = containerArrayPath ? containerArrayPath + '.' + path + multiLanguagePath : path + multiLanguagePath;
    const classes = useStyles();

    useEffect(() => {
        setSelectedLanguage(userLanguage)
        getLanguages();
    }, [userLanguage])

    useEffect(() => {
        let param = findByString(globalValues.param[screenName], paramPath) || "";
        setText(param);
    }, [path, JSON.stringify(globalValues), paramPath]);

    async function getLanguages() {
        try {
            const languages = await listRequestWrapper('language');
            setAvailableLng(languages)
        } catch (e) {
            console.log(e)
        }
    }

    const onChange = useCallback((text) => {
        if (disabled) return;
        setText(text);
        setValue(text, paramPath)

    }, [disabled, paramPath])

    return (
        <div style={{width: '100%'}}>
            {multiLanguage ? (
                <div style={{display: 'flex'}}>

                    <div style={{paddingLeft: 15, width: '100%'}}>
                        <QuillRender
                            text={text}
                            currentStyles={currentStyles}
                            onChange={onChange}
                            preserveWhitespace={preserveWhitespace}
                        />
                    </div>
                    <Tabs
                        orientation={"vertical"}
                        value={selectedLanguage}
                        indicatorColor={"primary"}
                        onChange={(e, v) => setSelectedLanguage(v)}
                    >
                        {availableLng.map(lng => {
                            return (
                                <Tab
                                    key={uid(lng)}
                                    label={lng.name}
                                    style={{padding: 5}}
                                    classes={{root: classes.tabRoot, selected: classes.selectedTab}}
                                    value={lng.id}
                                />
                            )
                        })}
                    </Tabs>
                </div>
            ) : (
                <QuillRender
                    text={text}
                    currentStyles={currentStyles}
                    onChange={onChange}
                    preserveWhitespace={preserveWhitespace}
                />
            )}

        </div>

    )
};

export default TextEditor

TextEditor.propTypes = {
    setValue: PropTypes.func,
    globalValues: PropTypes.object,
    path: PropTypes.string,
    screenName: PropTypes.string,
    currentStyles: PropTypes.object,
    disabled: PropTypes.bool,
    containerArrayPath: PropTypes.string,
    multiLanguage: PropTypes.bool
};

const QuillRender = ({currentStyles, text, onChange, preserveWhitespace = false}) => (
    <div
        style={{
            overflow: 'auto',
            width: currentStyles.width,
            height: currentStyles.height || 'auto',
            margin: currentStyles.margin
        }}
    >
        <QuillTextEditor
            value={text}
            onChange={onChange}
            preserveWhitespace={preserveWhitespace}
        />
    </div>
)